// extracted by mini-css-extract-plugin
module.exports = {"zgAppContainer":"RouterHelper_zgAppContainer__2F9gP"};